import React from "react";
import {
    AppBar, Toolbar as ToolbarMui, IconButton, Tabs, Tab, Drawer,
    Divider, List, ListItem, ListItemIcon, ListItemText,
    Typography, Grid, Box
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import PendingActionsOutlinedIcon from "@mui/icons-material/PendingActionsOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";

import AliceCarousel from "react-alice-carousel";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";

import { MarketComponent } from "./MarketComponent";
import { TabPanel } from "./TabPanelComponent";
import { BasketComponent } from "./BasketComponent";
import { BottomMenu } from "./HookUtils";

import AvatarIcon from "../assets/icons/avatar.svg";
import {
    AVATAR_BASE_URL_API,
    BANNER_BASE_URL_API,
    BASE_URL_API
} from "../Const";
import { CardShopRepository } from "../Repository/CardShopRepository";

import "react-alice-carousel/lib/alice-carousel.css";

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-start',
}));

export class ToolbarComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchedCategories: [],
            cardShopCount: 0,
            userData: null,
            banners: [],
            value: 0,
            open: false,
        };
    }

    componentDidMount() {
        const token = localStorage.getItem("pwa_token");

        this.setState({
            cardShopCount: CardShopRepository.getAll()?.length || 0
        });

        fetch(BASE_URL_API + 'category', {
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(results => this.setState({ fetchedCategories: results.data }))
            .catch(console.error);

        fetch(BASE_URL_API + 'banner?type=home')
            .then(res => res.json())
            .then(results => this.setState({ banners: results.data }))
            .catch(console.error);

        fetch(BASE_URL_API + 'user', {
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        })
            .then(res => res.json())
            .then(results => {
                if (results.code === "200") {
                    this.setState({ userData: results.data });
                }
            })
            .catch(console.error);
    }

    handleChange = (event, newValue) => {
        this.setState({ value: newValue });
    };

    handleDrawerOpen = () => {
        this.setState({ open: true });
    };

    handleDrawerClose = () => {
        this.setState({ open: false });
    };

    render() {
        const { open, fetchedCategories, value, userData, banners } = this.state;

        const drawerOptions = [
            { icon: <PendingActionsOutlinedIcon />, text: 'سوابق تراکنش', link: '/transaction' },
            { icon: <ShoppingBasketOutlinedIcon />, text: 'سفارشات', link: '/order' },
            { icon: <ReduceCapacityOutlinedIcon />, text: 'درباره ما', link: '/about-us' },
            { icon: <PrivacyTipOutlinedIcon />, text: 'قوانین و مقررات', link: '/privacy-policy' },
        ];

        return (
            <>
                <AppBar position="static" sx={{ background: '#ffffffcc', boxShadow: 'none' }}>
                    <ToolbarMui>
                        {userData ? (
                            <IconButton edge="start" onClick={this.handleDrawerOpen} size="large">
                                <MenuIcon sx={{ color: '#000' }} />
                            </IconButton>
                        ) : (
                            <IconButton
                                edge="start"
                                component={Link}
                                to="/verify"
                                size="large"
                                sx={{ color: '#000', fontSize: 14 }}
                            >
                                ورود
                            </IconButton>

                        )}

                        <ListItemText
                            primary="Hamekara"
                            sx={{ color: '#000', textAlign: 'center', flex: 1, fontWeight: 'bold' }}
                        />
                        <IconButton component={Link} to="/search" size="large">
                            <SearchIcon sx={{ color: '#000' }} />
                        </IconButton>
                        <IconButton size="large">
                            <BasketComponent />
                        </IconButton>
                    </ToolbarMui>

                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        variant="scrollable"
                        indicatorColor="primary"
                        textColor="secondary"
                    >
                        <Tab key="-1" label="همه بازارها" />
                        {fetchedCategories.map(category => (
                            <Tab key={category.id} label={category.title} />
                        ))}
                    </Tabs>
                </AppBar>

                <Drawer
                    anchor="left"
                    open={open}
                    onClose={this.handleDrawerClose}
                    sx={{
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            direction: 'rtl', // ✅ reinforce direction
                            right: 0,
                            left: 'auto',
                        },
                    }}
                >

                <DrawerHeader>
                        <IconButton onClick={this.handleDrawerClose} size="large">
                            <ChevronLeftIcon />
                        </IconButton>
                    </DrawerHeader>

                    <Box px={2}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={3}>
                                <img
                                    src={userData?.picture?.url
                                        ? `${AVATAR_BASE_URL_API}${userData.picture.url}`
                                        : AvatarIcon}
                                    alt="User Avatar"
                                    style={{ width: 48, height: 48, borderRadius: '50%' }}
                                />
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle1" fontWeight="bold" color="green">
                                    {userData?.name}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    {userData?.phone}
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    موجودی: {userData?.wallet}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <List>
                        {drawerOptions.map((item, idx) => (
                            <ListItem button key={idx} component={Link} to={item.link}>
                                <ListItemIcon>{item.icon}</ListItemIcon>
                                <ListItemText primary={item.text} sx={{ textAlign: 'right' }} />
                            </ListItem>
                        ))}
                    </List>
                </Drawer>

                {/* TabPanel for ALL MARKETS */}
                <TabPanel value={value} index={0}>
                    <AliceCarousel
                        autoPlay
                        autoPlayInterval={3000}
                        animationDuration={800}
                        infinite
                        disableButtonsControls
                        disableDotsControls
                    >
                        {banners.map((banner, i) => (
                            <Box key={i} display="flex" justifyContent="center" mt={10}>
                                <img
                                    src={BANNER_BASE_URL_API + banner.picture.url}
                                    alt={`banner-${i}`}
                                    style={{ width: '85%', height: 280, objectFit: 'contain' }}
                                />
                            </Box>
                        ))}
                    </AliceCarousel>

                    <MarketComponent parent_category_id={-1} />
                </TabPanel>

                {/* TabPanels for each CATEGORY */}
                {fetchedCategories.map((category, index) => (
                    <TabPanel key={category.id} value={value} index={index + 1}>
                        <AliceCarousel
                            autoPlay
                            autoPlayInterval={3000}
                            animationDuration={800}
                            infinite
                            disableButtonsControls
                            disableDotsControls
                        >
                            {banners.map((banner, i) => (
                                <Box key={i} display="flex" justifyContent="center" mt={10}>
                                    <img
                                        src={BANNER_BASE_URL_API + banner.picture.url}
                                        alt={`banner-${i}`}
                                        style={{ width: '85%', height: 280, objectFit: 'contain' }}
                                    />
                                </Box>
                            ))}
                        </AliceCarousel>

                        <MarketComponent parent_category_id={category.id} />
                    </TabPanel>
                ))}

                <BottomMenu />

                <Box
                    component="footer"
                    sx={{
                        backgroundColor: '#1e1e1e',
                        color: '#f1f1f1',
                        px: 3,
                        py: 4,
                        mt: 6,
                        fontSize: 14,
                        textAlign: 'center'
                    }}
                >
                    <Grid container spacing={3} justifyContent="center">
                        <Grid item xs={12} sm={4}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                درباره همه کارا
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 1 }}>
                                سامانه فروشگاهی <strong>همه کارا</strong> راهکاری نوین برای مدیریت فروشگاه‌های آنلاین و آفلاین است. با امکانات ثبت سفارش، باشگاه مشتریان، گزارش‌ گیری مالی و پشتیبانی.
                            </Typography>
                            <a
                                href="https://intro.hamekara.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#4fc3f7', textDecoration: 'none', fontWeight: 'bold' }}
                            >
                                معرفی کامل همه کارا
                            </a>
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
                                تماس با ما
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>📞 0383-228-5853</Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>📧 thetoptraders@gmail.com</Typography>
                            <Typography variant="body2"> 📍 ایران - شهرکرد - ساختمان علم و فناوری پردیس - طبقه سوم - واحد 305</Typography>
                        </Grid>

                        <Grid item xs={12} sm={4} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            <div className="trust-badge">
                                <a
                                    referrerPolicy="origin"
                                    target="_blank"
                                    href="https://trustseal.enamad.ir/?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                >
                                    <img
                                        referrerPolicy="origin"
                                        src="https://trustseal.enamad.ir/logo.aspx?id=618220&Code=W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                        alt=""
                                        style={{ cursor: "pointer" }}
                                        code="W86FGXOVhlD2RNWlNLWwxE5EVujECL5N"
                                    />
                                </a>
                            </div>
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 3, bgcolor: '#555' }} />

                    <Typography variant="caption" sx={{ color: '#aaa' }}>
                        © {new Date().getFullYear()} Hamekara.com - کلیه حقوق محفوظ است
                    </Typography>
                </Box>

            </>
        );
    }
}
